import { css } from '~ui-kit/styled-components';

export const BaseCss = css`
  * {
    /** Firefox scrollbar properties **/
    scrollbar-color: #d5d5d5 transparent;
    scrollbar-width: thin;
  }

  body {
    color: #24221f;
    background-color: #ffffff;
    overflow-x: hidden;
    overflow-y: scroll;
    font-size: 1.6rem;
    font-family: ${(props) => props.theme.fontFamily.montserrat};
    line-height: 1.3;
  }

  html,
  body {
    -webkit-tap-highlight-color: transparent;
    height: 100%;
  }

  /** Chrome, safari and edge scrollbar properties**/
  *::-webkit-scrollbar {
    background-color: transparent;
    width: 0.3em;
    height: 0.3em;
  }
  *::-webkit-scrollbar-button {
    display: none;
  }
  *::-webkit-scrollbar-thumb {
    background-color: #d5d5d5;
    border-radius: 10px;
  }

  #root {
    height: 100%;
  }

  *,
  *::before,
  *::after {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
    text-rendering: optimizeLegibility;
    box-sizing: border-box;
  }

  a,
  a:visited,
  a:hover,
  a:active {
    text-decoration: none;
  }

  p {
    font-size: 1rem;
    margin-bottom: 12px;
  }

  h1,
  h2,
  h3,
  h4 {
    margin-bottom: 12px;
  }
`;
